import { useSelector } from 'react-redux'
import { makeStyles } from '@mui/styles'
import classNames from 'classnames'
import { LanguageUtils, type Nil } from '@pbt/pbt-ui-components'

import MarketplaceDeactivatedLink from '~/components/dashboard/admin/marketplace/MarketplaceDeactivatedLink'
import FeatureToggle from '~/constants/featureToggle'
import {
  getBusinessSoapWidgets,
  getRenamedBusinessSoapWidgets,
} from '~/store/reducers/businesses'
import { getFeatureToggle } from '~/store/reducers/constants'

const useStyles = makeStyles(
  (theme) => ({
    span: {
      '&:not(:last-child)::after': {
        content: "',\\00a0'",
      },
    },
    deactivated: {
      color: theme.colors.lowAccentText,
      display: 'contents',
    },
  }),
  { name: 'SoapWidgetsTableCell' },
)

export interface SoapWidgetsTableCellProps {
  active: boolean
  id: string
  marketplaceId: string | Nil
}

const SoapWidgetsTableCell = ({
  active,
  id,
  marketplaceId,
}: SoapWidgetsTableCellProps) => {
  const classes = useStyles()

  const BusinessSoapWidgets = useSelector(getBusinessSoapWidgets)!
  const RenamedBusinessSoapWidgets = useSelector(getRenamedBusinessSoapWidgets)!
  const isDefaultSoapNotesTemplatesEnabled = useSelector(
    getFeatureToggle(FeatureToggle.SET_DEFAULT_SOAP_NOTE_TEMPLATES),
  )
  const deactivatedMarketplace = !active && marketplaceId

  return (
    <span
      className={classNames(classes.span, {
        [classes.deactivated]: deactivatedMarketplace,
      })}
      id="soap-template-tab-widget-names"
    >
      {deactivatedMarketplace ? (
        <MarketplaceDeactivatedLink id={id} marketplaceId={marketplaceId} />
      ) : (
        LanguageUtils.getConstantTranslatedName(
          id,
          isDefaultSoapNotesTemplatesEnabled
            ? RenamedBusinessSoapWidgets
            : BusinessSoapWidgets,
        )
      )}
    </span>
  )
}

export default SoapWidgetsTableCell
